/**
 * Default Categories and Districts
 * Used as fallback/default values in admin forms
 */

export const DEFAULT_CATEGORIES = [
  "देश-विदेश",
  "उत्तर प्रदेश",
  "चित्रकूट",
  "राजनीति",
  "शिक्षा",
  "धर्म",
  "मनोरंजन",
  "इतिहास",
  "वीडियो"
];

export const DEFAULT_DISTRICTS = [
  "चित्रकूट",
  "बांदा",
  "महोबा",
  "हमीरपुर",
  "प्रयागराज",
  "इलाहाबाद",
  "वाराणसी",
  "गाजीपुर",
  "मिर्जापुर"
];

export const DISTRICT_BLOCKS = {
  "चित्रकूट": [
    "कर्वी",
    "पहाड़ी",
    "मानिकपुर",
    "मऊ",
    "रामनगर"
  ],
  "बांदा": [
    "बांदा",
    "ता",
    "नरैनी",
    "माहिल"
  ],
  "महोबा": [
    "महोबा",
    "जैतपुर"
  ],
  "हमीरपुर": [
    "हमीरपुर",
    "राठ"
  ],
  "प्रयागराज": [
    "प्रयागराज",
    "फतेहपुर",
    "कौशांबी"
  ]
};

export const DISTRICT_VILLAGES = {
  "चित्रकूट": {
    "कर्वी": [
      "कर्वी",
      "सीतापुर",
      "कोलगड़ा",
      "भरतकूप",
      "रानीपुर"
    ],
    "पहाड़ी": [
      "पहाड़ी",
      "देवल",
      "सिरसावन",
      "अमरपुर",
      "सकरी"
    ],
    "मानिकपुर": [
      "मानिकपुर",
      "राजापुर",
      "हनुमानगंज",
      "चिल्ली राकस",
      "कछार"
    ],
    "मऊ": [
      "मऊ",
      "खरौंध",
      "बरहा",
      "लोधवारा",
      "कोटरा"
    ],
    "रामनगर": [
      "रामनगर",
      "नयागांव",
      "बरुआ",
      "तेंदुरा",
      "कुर्रुहू"
    ]
  }
};
